import { useTranslations } from '@vocab/react';

import type { Market } from '../../types';

import translations from './.vocab';

export const useMarkets = (
  enabledMarkets?: Market[],
): Array<{ label: string; value: Market }> => {
  const { t } = useTranslations(translations);

  const MARKET_MAP: Record<Market, { label: string; value: Market }> = {
    AU: {
      label: t('AUSTRALIA'),
      value: 'AU',
    },
    HK: {
      label: t('HONG_KONG'),
      value: 'HK',
    },
    ID: {
      label: t('INDONESIA'),
      value: 'ID',
    },
    MY: {
      label: t('MALAYSIA'),
      value: 'MY',
    },
    NZ: {
      label: t('NEW_ZEALAND'),
      value: 'NZ',
    },
    PH: {
      label: t('PHILIPPINES'),
      value: 'PH',
    },
    SG: {
      label: t('SINGAPORE'),
      value: 'SG',
    },
    TH: {
      label: t('THAILAND'),
      value: 'TH',
    },
  };

  if (enabledMarkets && enabledMarkets.length > 0) {
    return enabledMarkets.map((market) => MARKET_MAP[market]);
  }

  return Object.values(MARKET_MAP);
};
